import { v4 as uuidv4 } from 'uuid';

const getCode = ()=> {
    const tempCode = uuidv4().replaceAll("-", "").toUpperCase();
    const first = tempCode[2] + tempCode[1] + tempCode[8] + tempCode[10] + tempCode[9];
    const final = tempCode[tempCode.length - 1] + tempCode[5] + tempCode[4] + tempCode[0];
    return first + final;
}

export default getCode;